import { render } from "./PublicNavbarPrimary.vue?vue&type=template&id=bd743052&ts=true"
import script from "./PublicNavbarPrimary.vue?vue&type=script&lang=ts"
export * from "./PublicNavbarPrimary.vue?vue&type=script&lang=ts"

import "./PublicNavbarPrimary.vue?vue&type=style&index=0&id=bd743052&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/header/PublicNavbarPrimary.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bd743052"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bd743052', __exports__)) {
    api.reload('bd743052', __exports__)
  }
  
  module.hot.accept("./PublicNavbarPrimary.vue?vue&type=template&id=bd743052&ts=true", () => {
    api.rerender('bd743052', render)
  })

}


export default __exports__